import { Reviews } from '@mui/icons-material';
import { Text } from '@ltvco/refresh-lib/theme';
import { CTAContent, CTAInner, CTAOuter } from './components';
import { COMMUNITY_BUZZ_CTA_DESCRIPTION } from 'components/CommunityBuzz/constants';

interface CommunityBuzzIntroCTAProps {
  make: string;
  model: string;
  year: string;
}

export const CommunityBuzzIntroCTA = ({
  make,
  model,
  year,
}: CommunityBuzzIntroCTAProps) => {
  const vehicleName = [year, make, model].filter(Boolean).join(' ');

  return (
    <CTAOuter>
      <CTAInner>
        <Reviews fontSize="large" color="secondary" />
        <CTAContent>
          <Text variant="h4">{COMMUNITY_BUZZ_CTA_DESCRIPTION.title}</Text>
          <Text variant="body1">
            {COMMUNITY_BUZZ_CTA_DESCRIPTION.descriptionWithVehicleName(
              vehicleName,
            )}
          </Text>
        </CTAContent>
      </CTAInner>
    </CTAOuter>
  );
};
